import React from "react";

interface ProductPriceRequestSubmittedProperties {
    readonly onClose: () => void;
    readonly email: string;
}

export default function ProductPriceRequestSubmitted({ onClose, email }: ProductPriceRequestSubmittedProperties): React.JSX.Element {
    return (
        <div className="modal-body shop-body make-offer-body">
            <p className="fakeh3">Uvidíme, co se dá dělat &#x1F642;</p>
            <p>Vaši nabídku prověřím a pokud to bude možné, rád Vám vyhovím. Ozvu se Vám brzy
                na&nbsp;email:&nbsp;<span>{email}</span>
            </p>
            <div className="text-right shop-body-button">
                <button type="button" className="btn btn-success" onClick={onClose}>Zavřít</button>
            </div>
        </div>
    );
}
